import { FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';

export const YearsBannerContainer = styled(FlexContainer)<{ $compensation?: boolean }>`
  padding: ${({ theme: { reference } }) => reference.dimension_16};
  background-color: ${({ theme: { system }, $compensation }) =>
    !$compensation && system.background.fds_sys_color_background_supersoft};
`;

export const YearsBannerContent = styled(FlexContainer)`
  max-width: 450px;
`;

export const ButtonsContainer = styled(FlexContainer)`
  border-top: 1px solid ${({ theme }) => theme.system.border.fds_sys_color_border_primary};
  padding: ${({ theme: { reference } }) => reference.dimension_16};
`;
